import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "tss-react/mui";
import DeviceStatus from "../../../../prejoin/components/web/preview/DeviceStatus";
import Toolbox from "../../../../toolbox/components/web/Toolbox";
import { getConferenceName } from "../../../conference/functions";
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS, } from "../../../config/constants";
import { getToolbarButtons, isToolbarButtonEnabled, } from "../../../config/functions.web";
import { withPixelLineHeight } from "../../../styles/functions.web";
import ConnectionStatus from "./ConnectionStatus";
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import Preview from "./Preview";
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            height: "100%",
            position: "absolute",
            inset: "0 0 0 0",
            display: "flex",
            flexDiredtion: "column",
            backgroundColor: theme.palette.ui01,
            zIndex: 252,
            "@media (max-width: 1090px)": {
                flexDirection: "column-reverse",
            },
        },
        content: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,
            boxSizing: "border-box",
            float: "none",
            margin: " 0 auto",
            marginTop: theme.spacing(3),
            width: "100%",
            maxWidth: "55%",
            padding: "24px 0 16px",
            position: "relative",
            borderRadius: "10px",
            background: "#000",
            height: "100%",
            zIndex: 252,
            "@media (max-width: 720px)": {
                height: "auto",
                margin: "0 auto",
            },
            "@media screen and (min-width:720px) and (max-width: 1090px)": {
                maxWidth: "100%",
            },
            // mobile phone landscape
            "@media (max-width: 420px)": {
                padding: "16px 16px 0 16px",
                width: "100%",
            },
            "@media screen and (min-width:300px) and (max-width: 500px)": {
                maxWidth: "100%",
            },
        },
        contentControls: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            textAlign: "left",
            margin: "auto",
            width: "96%",
            justifyContent: "space-around",
            "@media (max-width: 1090px)": {
                flexDirection: "column",
            },
            "@media screen and (min-width:1350px) and (max-width: 2500px)": {
                width: "100% !important",
            },
        },
        title: {
            ...withPixelLineHeight(theme.typography.heading4),
            color: `${theme.palette.text01}!important`,
            marginBottom: theme.spacing(3),
            textAlign: "left",
            "@media (max-width: 1090px)": {
                display: "none !important",
            },
        },
        roomName: {
            ...withPixelLineHeight(theme.typography.heading6),
            color: theme.palette.text01,
            // marginBottom: theme.spacing(4),
            overflow: "hidden",
            textAlign: "center",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
            // background:"#282828",
            marginLeft: theme.spacing(4),
            padding: "12px",
            "@media (max-width: 1090px)": {
                marginLeft: '0px',
                // marginBottom: theme.spacing(4),
            },
        },
        connectionView: {
            position: "absolute",
            width: "100%",
            "@media (max-width: 1090px)": {
                background: 'black'
            },
        },
        toolbarControls: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            float: "none",
            margin: " 0 auto",
            marginTop: theme.spacing(3),
            borderRadius: "10px",
            width: "100%",
            maxWidth: "55%",
            background: "#000",
            padding: "4px 0px",
            justifyContent: "space-around",
            // "@media (max-width: 1240px)": {
            //     maxWidth: "90%",
            //     justifyContent:"space-around",
            // },
            "@media (max-width: 1090px)": {
                maxWidth: "100%",
                flexDirection: "column-reverse",
                justifyContent: "space-around",
            },
        },
        deviceStatus: {
            "@media (max-width: 1090px)": {
                display: "none",
            },
        },
        roomNamembl: {
            width: "100%",
            textAlign: "center",
            "@media (max-width: 1090px)": {
                display: "none",
            },
        },
        deviceStatusWeb: {
            display: "none",
            "@media (max-width: 1090px)": {
                display: "flex",
            },
        },
        roomNameWeb: {
            display: "none",
            "@media (max-width:1090px)": {
                display: "flex",
            },
        },
        toolallign: {
            width: '100%'
        },
    };
});
const PreMeetingScreen = ({ _buttons, _premeetingBackground, _roomName, children, className, showDeviceStatus, skipPrejoinButton, title, videoMuted, videoTrack, }) => {
    const { classes } = useStyles();
    const style = _premeetingBackground
        ? {
            background: _premeetingBackground,
            backgroundPosition: "center",
            backgroundSize: "cover",
        }
        : {};
    let videoNodeEl = document.querySelectorAll(".video-preview-container");
    if (videoNodeEl.length == 2) {
        videoNodeEl[0].remove();
    }
    let audioNodeEl = document.querySelectorAll(".audio-preview-content");
    if (audioNodeEl.length == 2) {
        audioNodeEl[0].remove();
    }
    return (React.createElement("div", { className: clsx("premeeting-screen", classes.container, className) },
        React.createElement("div", { style: style, className: classes.connectionView },
            React.createElement("div", { className: classes.content },
                React.createElement(ConnectionStatus, null),
                React.createElement("div", { className: classes.contentControls },
                    React.createElement("div", null,
                        React.createElement("h1", { className: classes.title }, title),
                        React.createElement("span", { className: classes.deviceStatus },
                            " ",
                            showDeviceStatus && React.createElement(DeviceStatus, null)),
                        React.createElement("span", { className: classes.roomNameWeb },
                            " ",
                            _roomName && (React.createElement("span", { className: classes.roomName }, _roomName)))),
                    children,
                    skipPrejoinButton)),
            React.createElement("div", { className: classes.toolbarControls },
                React.createElement("span", { className: classes.roomNamembl },
                    "  ",
                    _roomName && (React.createElement("span", { className: classes.roomName }, _roomName))),
                React.createElement("span", { className: classes.deviceStatusWeb },
                    "  ",
                    showDeviceStatus && React.createElement(DeviceStatus, null)),
                React.createElement("span", { className: classes.toolallign },
                    " ",
                    _buttons.length && (React.createElement(Toolbox, { toolbarButtons: _buttons }))))),
        React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack })));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, hideConferenceSubject } = state["features/base/config"];
    const toolbarButtons = getToolbarButtons(state);
    const premeetingButtons = (ownProps.thirdParty ? THIRD_PARTY_PREJOIN_BUTTONS : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const { premeetingBackground } = state["features/dynamic-branding"];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter((b) => isToolbarButtonEnabled(b, toolbarButtons)),
        _premeetingBackground: premeetingBackground,
        _roomName: (hideConferenceSubject ? undefined : getConferenceName(state)) ??
            "",
    };
}
export default connect(mapStateToProps)(PreMeetingScreen);
